var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service"},_vm._l((_vm.list),function(item){return _c('div',[_c('ServiceItem',{attrs:{"serviceItem":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }